/**
 * Registry of admin pages under /admin.
 * Add new entries here when you create a route in App.js.
 */
export const ADMIN_PAGES = [
  {
    path: "/admin/venues/payments",
    title: "Venue payments",
    description:
      "Enable Stripe payment UI, platform fee, and optional booking deposits per venue.",
    section: "Venues"
  },
  {
    path: "/admin/venues/pricing",
    title: "Public pricing visibility",
    description:
      "Show or hide venue rates on search, the booking calendar, and the booking form.",
    section: "Venues"
  },
  {
    path: "/admin/venue-onboarding/invites",
    title: "Venue onboarding invites",
    description:
      "Generate one-time invite codes and links for gated venue self-serve signup.",
    section: "Venues"
  },
  {
    path: "/admin/organizers",
    title: "Event organiser profiles",
    description:
      "Look up an organiser by user ID or email and view their bookings as they see them.",
    section: "Bookings"
  },
  {
    path: "/admin/manual-bookings",
    title: "Manual bookings",
    description:
      "Review venue brief requests, finalize payment amounts, and manage manual booking records.",
    section: "Bookings"
  },
  {
    path: "/admin/catalog-addon-tags",
    title: "Catalog tags",
    description:
      "Manage Food, Beverage, and other filter tags for packages and add-ons on the booking page.",
    section: "Venues"
  }
];

export const ADMIN_SECTION_ORDER = ["Venues", "Bookings"];

export const adminPagesBySection = () => {
  const grouped = new Map();
  ADMIN_SECTION_ORDER.forEach((section) => grouped.set(section, []));
  ADMIN_PAGES.forEach((page) => {
    const section = page.section || "Other";
    if (!grouped.has(section)) grouped.set(section, []);
    grouped.get(section).push(page);
  });
  return [...grouped.entries()].filter(([, pages]) => pages.length > 0);
};
